import L, { Icon } from 'leaflet';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerIconShadow from 'leaflet/dist/images/marker-shadow.png';
import React from 'react';
import { MapContainer, Marker, TileLayer, ZoomControl } from 'react-leaflet';

import 'leaflet/dist/leaflet.css';

import { Skeleton } from '@/components/atoms/Skeleton';
import { Spinner } from '@/components/atoms/Spinner';

import { MapController } from './MapController';

export type Coordinates = {
  latitude: number;
  longitude: number;
};

const defaultMarkerIcon = new L.Icon({
  iconUrl: markerIcon,
  shadowUrl: markerIconShadow,
  iconSize: [25, 41], // Taille de l'icône
  iconAnchor: [12, 41], // Ancre de l'icône
  popupAnchor: [1, -34], // Ancre pour les popups
  shadowSize: [41, 41] // Taille de l'ombre
});

export type LeafletMapProps = {
  height: string;
  width: string;
  initialCenter: Coordinates;
  defaultZoom?: number;
  customMarker?: Icon;
  minZoom?: number;
  maxZoom?: number;
  onMove?: (coordinates: Coordinates) => void;
  isLocationLoading?: boolean;
  disableCopyright?: boolean;
  disableMarker?: boolean;
};

export const LeafletMap: React.FC<LeafletMapProps> = ({
  height,
  width,
  customMarker,
  initialCenter,
  defaultZoom,
  minZoom,
  maxZoom,
  onMove,
  isLocationLoading,
  disableCopyright = false,
  disableMarker = false
}) => {
  return (
    <div style={{ height, width }} className="flex items-center justify-center relative">
      {isLocationLoading ? (
        <>
          <div className="absolute left-[50%] z-50 ml-[-10px] h-[30px] w-[30px]">
            <Spinner />
          </div>
          <Skeleton />
        </>
      ) : (
        <>
          <MapContainer
            center={[initialCenter.latitude, initialCenter.longitude]}
            zoom={defaultZoom}
            minZoom={minZoom}
            maxZoom={maxZoom}
            scrollWheelZoom={false}
            style={{ height, width }}
            className="z-0 !rounded-none"
            zoomControl={false}
          >
            <MapController initialCenter={initialCenter} onMove={onMove} />
            <ZoomControl position="topright" />

            {!disableMarker && initialCenter && (
              <Marker icon={customMarker || defaultMarkerIcon} position={[initialCenter.latitude, initialCenter.longitude]} />
            )}
            <TileLayer
              minZoom={minZoom}
              minNativeZoom={minZoom}
              maxZoom={maxZoom}
              maxNativeZoom={maxZoom}
              attribution={disableCopyright ? '' : '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}
              url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}{r}.png"
            />
          </MapContainer>
        </>
      )}
    </div>
  );
};
